(function($){
    // JS
    window.Resources = {

        // Google Analytics Resources Tracking
        //======================================================================
        eventTracking: function()
        {
             
            $('.resource_download').on('click', function(){
                var downloadTitle = $(this).data('resource');

                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Resources Download',
                    eventAction: 'File Download',
                    eventLabel: downloadTitle + ' Downloaded' 
                });
            });

        }



    }
    // Run
    $(function(){
        Resources.eventTracking();
    });


}(jQuery));